import { useMemo } from 'react';

export const useIsOptionRichText = (text: string) => {
	const isOptionRichText = useMemo(() => /^\s*<block>.*<\/block>\s*$/.test(text), [text]);

	return isOptionRichText;
};
